// WCAG AA contrast fix for the small "X/Y voted" / "X/Y pending" subtext labels
// used across poll summaries. The original `text-emerald-600` (3.76:1) and
// `text-amber-600` (3.18:1) both fail the 4.5:1 threshold for normal-size text
// on a white/card background. Stepping one shade darker to emerald-700/amber-700
// clears AA in light mode (≈5.5:1 and ≈5.0:1 respectively); the dark variants
// stay on the bright -300 shades, which already pass on the dark card surface.
//
// Centralizing this keeps the fix consistent everywhere the same status subtext
// appears (poll participant summary, poll status meta, dashboard session card)
// and gives a single place to re-test if the palette changes.

const TONE_CLASSES = Object.freeze({
  voted: "text-emerald-700 dark:text-emerald-300",
  pending: "text-amber-700 dark:text-amber-300",
});

export function statusToneClass(kind) {
  return TONE_CLASSES[kind] || "";
}

export const votedToneClass = TONE_CLASSES.voted;
export const pendingToneClass = TONE_CLASSES.pending;
